export default {
  Variation2: "variation2",
  Variation3: "variation3",
  Variation4: "variation4",
  Variation5: "variation5",
  ControlFr: "controlfr",
  Variation1Fr: "variation1fr",
  Variation2Fr: "variation2fr",
};
